<template>
  <div :class="[$style.container, isClient ? $style.clientContainer : $style.h5Container]" :style="{ backgroundImage: `url('${background}')` }">
    <!-- 动态渲染登录相关组件 -->
    <component
      v-for="view in activeLoginViews"
      :key="view.name"
      :is="view.component"
      :class="[view.wrapperClass]"
      v-bind="view.props"
      v-on="view.events"
      :ref="view.ref"
    />

    <!-- 平台特定组件 -->
    <template v-if="!isClient">
      <component
        v-for="view in activeH5Views"
        :key="view.name"
        :is="view.component"
        v-bind="view.props"
        v-on="view.events"
      />
    </template>

    <template v-if="isClient">
      <component
        v-for="view in activeClientViews"
        :key="view.name"
        :is="view.component"
        v-bind="view.props"
        v-on="view.events"
      />
    </template>

    <!-- VIP客服 - 平台特定实现 -->
    <component
      v-if="userState.vipVisible"
      :is="vipCustomerComponent"
      v-bind="vipCustomerProps"
      v-on="vipCustomerEvents"
    />

    <!-- 通用组件 -->
    <component
      v-for="view in activeCommonViews"
      :key="view.name"
      :is="view.component"
      :class="view.wrapperClass"
      v-bind="view.props"
      v-on="view.events"
    />

    <!-- 静默登录提示 -->
    <div :class="$style.hint" v-if="hintShow">
      用户（<span>{{ userState.username }}</span>），欢迎进入游戏。
    </div>
  </div>
</template>

<script>
// 通用组件
import QuickRegister from '@/components/login/RegisterV2/index.vue';
import CellLogin from '@/components/login/CellLogin/index.vue';
import Login from '@/components/login/LoginV2/index.vue';
import Reset from '@/components/login/Forgetpswds/index.vue';
import Affiche from '@/components/login/Affiche/index.vue';
import Charge from '@/components/charge/Charge/index.vue';
import Captcha from '@/components/login/Captcha/index.vue';
import Argument from '@/components/login/Argument/index.vue';
import ForceBindPhone from '@/components/login/ForceBindPhone/index.vue';
import ArgumentTip from '@/components/login/ArgumentTip/index.vue';
import WechatLogin from '@/components/login/WechatLogin/index.vue';
import WechatBindPhone from '@/components/login/WechatBindPhone/index.vue';

// H5/CX 特定组件
import Suspend from '@/views/h5/suspend.vue';
import FloatWindow from '@/views/h5/floatWindow.vue';
import ActivityPage from '@/views/h5/activityPage.vue';
import ForceOffline from '@/views/h5/forceOffline.vue';
import UpdateGift from '@/components/update/Gift.vue';
import GuideRemind from '@/components/charge/GuideRemind.vue';
import iosTips from '@/components/iosTips.vue';
import AntiIndulged from '@/views/h5/antiIndulged.vue';

// Client 特定组件
import ClientAntiIndulged from '@/views/client/anitiIndulged/antiIndulgedLogin.vue';
import YybLogin from '@/components/login/YybLogin';
import ForceUpdate from '@/components/update/Activity.vue';

// VipCustomer 组件
import VipCustomer from '@/components/VipCustomer.vue';

import { mapState } from 'vuex';
import { isAndroid, isSysName, getStorage, isSafari, isStandalone, getAccount,saveAccount, getCellAccount, setStorage, saveCellAccount, delCellAccount, saveAccountList } from '@/libs/utils.js';
import { CaptchaInit, CaptchaReset } from "@/libs/captcha";
import { telBindShow } from '@/api/user';

import { H5_LOGIN_WHITE_LIST, CLIENT_LOGIN_WHITE_LIST, CLIENT_AUTOLOGIN_WHITE_LIST, CLIENT_LOGIN_WHITE_ONLY_REG_LIST } from '@/config/whiteList';
import { get } from 'lodash';

// 视图配置常量
const VIEW_CONFIGS = {
  // 登录相关视图
  LOGIN: {
    CELL_LOGIN: 'cellLoginVisible',
    QUICK_REGISTER: 'quickRegisterVisible',
    LOGIN: 'loginVisible',
    RESET: 'resetVisible',
    WECHAT_LOGIN: 'wechatLoginVisible',
    WECHAT_BIND_PHONE: 'wechatBindPhoneVisible',
    FORCE_BIND: 'forceBindVisible',
  },
  // H5特定视图
  H5: {
    SUSPEND: 'suspendVisible',
    FLOAT_WINDOW: 'floatWindowVisible',
    GAME: 'gameVisible',
    ACTIVITY: 'activityShowInfo.visible',
    FORCE_OFFLINE: 'forceOfflineVisible',
    UPDATE_GIFT: 'updateGiftVisible',
    IOS_TIPS: 'iosTips',
  },
  // Client特定视图
  CLIENT: {
    ANTI_INDULGED: 'antiIndulgedVisible',
    YYB_LOGIN: 'yybLoginVisible',
    FORCE_UPDATE: 'forceUpdateVisible',
  },
  // 通用视图
  COMMON: {
    AFFICHE: 'afficheShow',
    CHARGE: 'chargeVisible',
    CAPTCHA: 'captchaVisible',
    ARGUMENT: 'argumentVisible',
  }
};

export default {
  name: 'CommonLoginV2',
  props: {
    platform: {
      type: String,
      required: true,
      validator: value => ['h5', 'client', 'cx'].includes(value)
    }
  },
  metaInfo() {
    if (this.isH5 || this.isCx) {
      return {
        title: this.$store.state.user.app_name,
        meta: [
          { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
          { name: 'apple-mobile-web-app-capable', content: 'yes' },
        ],
        link: [
          { rel: 'apple-touch-icon-precomposed', href: 'https://sdk-static.zhangyuqu.com/icon/app/slzs.png' }
        ],
      };
    }
    return {};
  },
  data() {
    return {
      registerCallback: '',
      cellForm: {},
      normalTelBind: false,
      argumentTipVisible: false,
      argumentHandle: {
        method: '',
        params: {}
      },
      hideRegister: true,
      hideCellLogin: false,
      hideWechatLogin: true,
      pageName: "",
      config_bind_force: 0,
      showWechatSelectOther: true,
      notifyInfo: {},
      isUseKsSdk: false,
    };
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      loginStatus: state => state.user.login_status,
      captchaStatus: state => state.user.captcha_status,
      activityShowInfo: state => state.activity.activity_show_info || {},
      background: state => state.user.background,
      guideRemindVisible: state => state.pay.guideRemindVisible,
      hintShow: state => state.user.silentHintShow,
      guideBrowserVisible: state => state.pay.guideBrowserVisible,
    }),
    
    isClient() {
      return this.platform === 'client';
    },
    
    isH5() {
      return this.platform === 'h5';
    },
    
    isCx() {
      return this.platform === 'cx';
    },

    // 登录相关视图配置
    loginViewsConfig() {
      return [
        {
          name: 'cellLogin',
          component: CellLogin,
          visible: this.userState.cellLoginVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : ''],
          props: {
            hideRegister: this.hideRegister,
            hideWechatLogin: this.hideWechatLogin,
          },
          events: {
            redirectRegist: this.redirectRegist,
            redirectWechatLogin: this.otherLoginRedirectWechat,
            redirectAccountLogin: this.redirectAccountLogin,
            redirectArgument: this.redirectArgument,
            login: this.cellLogin,
          },
          ref: 'cellLogin'
        },
        {
          name: 'quickRegister',
          component: QuickRegister,
          visible: this.userState.quickRegisterVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : ''],
          props: {
            hideCellLogin: this.hideCellLogin,
          },
          events: {
            redirectAccountLogin: this.redirectAccountLogin,
            redirectCellLogin: this.redirectCellLogin,
            register: this.handleQuickRegister,
            redirectArgument: this.redirectArgument,
          }
        },
        {
          name: 'login',
          component: Login,
          visible: this.userState.loginVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : ''],
          props: {
            hideRegister: this.hideRegister,
            hideCellLogin: this.hideCellLogin,
            hideWechatLogin: this.hideWechatLogin,
          },
          events: {
            login: this.handleLogin,
            redirectRegist: this.redirectRegist,
            redirectForget: this.redirectForget,
            redirectArgument: this.redirectArgument,
            redirectCellLogin: this.redirectCellLogin,
            redirectWechatLogin: this.otherLoginRedirectWechat,
          }
        },
        {
          name: 'reset',
          component: Reset,
          visible: this.userState.resetVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : ''],
          props: {},
          events: {
            back: this.redirectLogin,
          }
        },
        {
          name: 'wechatLogin',
          component: WechatLogin,
          visible: this.userState.wechatLoginVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : '', this.$style.wechatLogin],
          props: {
            account: this.userState.wechatAccount,
            showWechatSelectOther: this.showWechatSelectOther,
          },
          events: {
            login: this.handleWchatLoginSubmit,
            redirOther: this.wechatLoginRedirectOther,
          }
        },
        {
          name: 'wechatBindPhone',
          component: WechatBindPhone,
          visible: this.userState.wechatBindPhoneVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : '', this.$style.wechatBindPhone],
          props: {
            config_bind_force: this.config_bind_force,
          },
          events: {
            close: this.handleLoginInfo,
          }
        },
        {
          name: 'forceBindPhone',
          component: ForceBindPhone,
          visible: this.userState.forceBindVisible,
          wrapperClass: '',
          props: {
            normalTelBind: this.normalTelBind,
            isClient: this.isClient,
          },
          events: {
            close: this.closeForceBind,
          }
        },
      ];
    },

    // H5特定视图配置
    h5ViewsConfig() {
      return [
        {
          name: 'suspend',
          component: Suspend,
          visible: this.userState.suspendVisible,
          props: {},
          events: {}
        },
        {
          name: 'floatWindow',
          component: FloatWindow,
          visible: this.userState.floatWindowVisible,
          props: {},
          events: {}
        },
        {
          name: 'gameFrame',
          component: 'iframe',
          visible: this.userState.gameVisible,
          props: {
            class: this.$style.gameFrame,
            name: 'gameFrame',
            src: this.userState.game_url,
          },
          events: {}
        },
        {
          name: 'activityPage',
          component: ActivityPage,
          visible: this.activityShowInfo.visible,
          props: {},
          events: {}
        },
        {
          name: 'forceOffline',
          component: ForceOffline,
          visible: this.userState.forceOfflineVisible,
          props: {},
          events: {}
        },
        {
          name: 'updateGift',
          component: UpdateGift,
          visible: this.userState.updateGiftVisible,
          props: {},
          events: {
            close: this.closeUpdateGift,
          }
        },
        {
          name: 'guideRemind',
          component: GuideRemind,
          visible: this.guideRemindVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : ''],
          props: {},
          events: {
            close: this.closeGuideRemind,
          }
        },
        {
          name: 'iosTips',
          component: iosTips,
          visible: this.userState.iosTips,
          props: {},
          events: {}
        },
        {
          name: 'guideBrowser',
          component: 'img',
          visible: this.guideBrowserVisible,
          props: {
            src: `${this.$cdnLink}/common/lead.png`,
            alt: '',
            class: this.$style.guideBrowser,
          },
          events: {
            click: this.hideGuideBrowser,
          }
        },
        {
          name: 'h5AntiIndulged',
          component: AntiIndulged,
          visible: this.userState.antiIndulgedVisible,
          props: {},
          events: {
            notifyLogin: this.enterGame,
          }
        },
      ];
    },

    // Client特定视图配置
    clientViewsConfig() {
      return [
        {
          name: 'clientAntiIndulged',
          component: ClientAntiIndulged,
          visible: this.userState.antiIndulgedVisible,
          props: {},
          events: {
            toLogin: this.antiIndulgedLogin,
          }
        },
        {
          name: 'yybLogin',
          component: YybLogin,
          visible: this.userState.yybLoginVisible,
          props: {},
          events: {}
        },
        {
          name: 'forceUpdate',
          component: ForceUpdate,
          visible: this.userState.forceUpdateVisible,
          props: {},
          events: {}
        },
      ];
    },

    // 通用视图配置
    commonViewsConfig() {
      return [
        {
          name: 'affiche',
          component: Affiche,
          visible: this.userState.afficheShow,
          props: {
            isClient: this.isClient,
            isUseKsSdk: this.isUseKsSdk,
          },
          events: {
            close: this.closeAffiche,
          }
        },
        {
          name: 'charge',
          component: Charge,
          visible: this.userState.chargeVisible,
          props: {},
          events: {
            close: this.closeChargeWindow,
          }
        },
        {
          name: 'captcha',
          component: Captcha,
          visible: this.userState.captchaVisible,
          wrapperClass: this.$style.captcha,
          props: {
            isClient: this.isClient,
          },
          events: {
            captchaInit: this.captchaInit,
          }
        },
        {
          name: 'argument',
          component: Argument,
          visible: this.userState.argumentVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : '', this.$style.argument],
          props: {
            isClient: this.isClient,
          },
          events: {
            redirectRegist: this.argumentReturn,
          }
        },
        {
          name: 'argumentTip',
          component: ArgumentTip,
          visible: this.argumentTipVisible,
          wrapperClass: [this.$style.outer, this.background == '' ? this.$style.mask : '', this.$style.argumentTip],
          props: {},
          events: {
            agreeArgument: this.agreeArgument,
            back: () => { this.argumentTipVisible = false },
            showArgument: this.redirectArgument,
          }
        },
      ];
    },

    // 激活的视图（过滤出visible为true的）
    activeLoginViews() {
      return this.loginViewsConfig.filter(view => view.visible);
    },

    activeH5Views() {
      return this.h5ViewsConfig.filter(view => view.visible);
    },

    activeClientViews() {
      return this.clientViewsConfig.filter(view => view.visible);
    },

    activeCommonViews() {
      return this.commonViewsConfig.filter(view => view.visible);
    },

    // VIP客服组件配置
    vipCustomerComponent() {
      if (this.isClient) {
        return {
          template: `
            <VipCustomer
              @close="$emit('close')" 
              @openUrl="$emit('openUrl')"
            ></VipCustomer>
          `,
          components: { VipCustomer }
        };
      } else {
        return {
          template: `
            <div :class="$style.vipCustomer">
              <VipCustomer :isH5="true" :class="$style.window" @close="$emit('close')"></VipCustomer>
            </div>
          `,
          components: { VipCustomer }
        };
      }
    },

    vipCustomerProps() {
      return this.isClient ? {} : {};
    },

    vipCustomerEvents() {
      return this.isClient ? {
        close: this.closeVipCustomer,
        openUrl: this.openUrl,
      } : {
        close: this.closeVipCustomer,
      };
    },
  },
  
  created() {
    localStorage.setItem('isV2Sdk', true);
    this.pageName = this.$store.state.user.app_name;
    
    this.platformInit();
    
    this.$store.commit('global/handleLinkParams', this.$route.query);
    this._handleType();
    
    if (this.$route.name == 'h5.silentLogin' || this.$route.name == 'client.silentLogin') {
      this.$store.commit('user/CHANGE_STATE', { loginVisible: false, cellLoginVisible: false });
      this.$setStorage('isSilentLogin', true);
    } else {
      this.$setStorage('isSilentLogin', false);
    }
    this._handleSkin();
  },
  
  mounted() {
    this.$store.dispatch('user/getCacheState');
    if (this.isH5 || this.isCx) {
      // console.log('H5桥接初始化开始');
      this._bridgeInit();
    } else if (this.isClient) {
      // console.log('Client桥接初始化开始');
      this._clientInit();
    }
  },
  
  components: {
    QuickRegister,
    CellLogin,
    Login,
    Reset,
    Affiche,
    Charge,
    Captcha,
    Argument,
    ForceBindPhone,
    ArgumentTip,
    WechatLogin,
    WechatBindPhone,
    Suspend,
    FloatWindow,
    ActivityPage,
    ForceOffline,
    UpdateGift,
    GuideRemind,
    iosTips,
    AntiIndulged,
    YybLogin,
    ForceUpdate,
    ClientAntiIndulged,
    VipCustomer,
  },
  
  methods: {
    /**
     * 检查微信登录凭证缓存
     * @returns {Object} { hasCredential: boolean, login_credential: string, wechatAccount: string }
     */
    checkWechatCredentialCache() {
      const wechat_login_credential = this.$getStorage('wechat_login_credential');
      const wechatAccount = this.$getStorage('wechatAccount');
      const v2LoginType = localStorage.getItem('v2LoginType');
      
      return {
        hasCredential: v2LoginType === 'wechat' && !!wechat_login_credential && !!wechatAccount,
        wechat_login_credential: wechat_login_credential,
        wechatAccount: wechatAccount
      };
    },

    /**
     * 处理微信登录显示逻辑
     * @param {string} source - 调用来源（用于日志）
     */
    handleWechatLoginVisibility(source = 'unknown') {
      const { hasCredential, wechat_login_credential, wechatAccount } = this.checkWechatCredentialCache();
      
      if (hasCredential && !this.isClient) {
        // 有凭证缓存，不显示微信登录页面
        // console.log(`${source}: 检测到微信凭证缓存，不显示登录页面`);
        this.$store.commit('user/CHANGE_STATE', {
          hideWechatLogin: false,
          cellLoginVisible: false,
          quickRegisterVisible: false,
          loginVisible: false,
          resetVisible: false,
          wechatLoginVisible: false,
          wechat_login_credential: wechat_login_credential,
          wechatAccount: wechatAccount
        });
        return true; // 返回 true 表示有凭证
      } else {
        // 无凭证缓存，显示微信登录页面
        // console.log(`${source}: 无微信凭证缓存，显示微信登录页面`);
        this.$store.commit('user/CHANGE_STATE', {
          hideWechatLogin: false,
          cellLoginVisible: false,
          quickRegisterVisible: false,
          loginVisible: false,
          resetVisible: false,
          wechatLoginVisible: true,
          wechat_login_credential: wechat_login_credential,
          wechatAccount: wechatAccount
        });
        return false; // 返回 false 表示无凭证
      }
    },

    // 平台初始化
    platformInit() {

      // console.log('平台初始化开始',getStorage('isNeedWeChatLogin'),getStorage('is_can_wechat_login'));
      if (getStorage('isNeedWeChatLogin') == 1 && getStorage('is_can_wechat_login')) {
        // console.log('需要微信登录，显示微信登录按钮');
        this.hideWechatLogin = false;
      }
      if (this.isH5) {
        this.$store.commit('user/CHANGE_STATE', { loginVisible: false, wechatLoginVisible: false, cellLoginVisible: true });
        
        if(H5_LOGIN_WHITE_LIST.has(this.$route.query.appid)){
          this.hideRegister = false;
          // this.hideWechatLogin = false;
        }
        
        if (this.$route.name === 'h5.external') {
          // console.log('检测到外部登录，进行外部登录初始化');
          this._externalInit();
          this.checkIosTips();
        } else if (!isAndroid()) {
          // console.log('非安卓设备，进行iOS初始化');
          this.checkIosTips();
          this._iosInit();
        }
        // console.log('H5平台初始化完成', this.hideWechatLogin);
      } else if (this.isClient) {
        this.$store.commit('user/CHANGE_STATE', { loginVisible: false, wechatLoginVisible: false, cellLoginVisible: true });
        this.hideRegister = false;
        // this.hideWechatLogin = true;
        this.$store.dispatch('handle/handleClientThirdPlatform', this.$route.query);
      } else if (this.isCx) {
        this.hideCellLogin = true;
        this.$store.commit('user/CHANGE_STATE', { loginVisible: true, wechatLoginVisible: false, cellLoginVisible: false });
        // console.log('CX平台初始化完成', this.hideWechatLogin);
      }
    },
    
    checkIosTips() {
      let iosTips = getStorage('iosTips');
      if ('iphone' == isSysName() && !iosTips && isSafari() && !isStandalone()) {
        this.$store.commit('user/CHANGE_STATE', { iosTips: true }, { root: true });
      }
    },

    _handleSkin() {
      const { skin } = this.$route.query;
      this.$setStorage('skin', skin || '');
    },

    async _iosInit() {
      const { initial, iosThirdPacket } = this.$route.query;
      // console.log('_iosInit: route query参数', this.$route.query);
      if (iosThirdPacket) {
        // console.log('_iosInit: 存在iosThirdPacket，初始化iOS第三方设备数据', this.$route.query); 
        await this.$store.dispatch('user/initIosThirdDeviceData', this.$route.query);
      } else if (initial) {
        // console.log('_iosInit: 存在initial，初始化iOS设备数据', this.$route.query);
        await this.$store.dispatch('user/initDeviceData', this.$route.query);
      }
    },

    _externalInit() {
      this.$store.dispatch('user/initExternalData', this.$route.query);
      this.$setStorage('externalLogin', true);
      this.hideRegister = true;
      this.hideWechatLogin = true;
      this.$store.commit('user/CHANGE_STATE', { loginVisible: true, cellLoginVisible: false });
    },

    _bridgeInit() {
      const { registJSInitial, thirdPartyLogins, innerPurchaseFunctionSuc, closeOrderFrame, checkOrderState, deviceFlip2H5, onBackPressed2H5, wechatEntryCode } = require('@/bridge/AppJsBridge');
      registJSInitial(async (e, cb) => {
        let data = JSON.parse(e);
        // console.log('H5桥接初始化数据接收完成', data);
        const { user_info, jsDataStorage, third_sdk_status } = data;

        if (user_info && user_info.length) {
          this.$store.commit('user/CHANGE_STATE', {
            userList: user_info,
            username: user_info[0].username,
            password: user_info[0].password
          });
        }

        this.$store.commit('user/CHANGE_STATE', {
          sdk_version: data.sdk_version,
          device_info: data.attributeReportParams,
          appkey: data.jh_app_id,
          channel: data.jh_channel,
          extra_data: JSON.stringify(data.extra_data),
          game_version: data.game_version,
          login_status: jsDataStorage || '',
          third_sdk_status: third_sdk_status || '',
          isEmulator: data.isEmulator,
          isInstallWeChat: data.isInstallWeChat,
          isInstallAlipay: data.isInstallAlipay,
        });
        await this.$store.dispatch('user/isNeedWeChatLogin');

        if (data.is_can_wechat_login) {
          setStorage('is_can_wechat_login', true);
        }

        if (third_sdk_status == 'false') {
          this.$store.commit('user/CHANGE_STATE', { login_status: 2 });
        }

        const cacheList = [
          'login_status',
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay'
        ];
        this.$store.dispatch('user/cacheState', cacheList);

        if (data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }

        this.$store.dispatch('user/getYsdkStatus', 1);
        this.$store.dispatch('user/affiche');

        // console.log('isNeedWeChatLogin:', this.userState.isNeedWeChatLogin, 'is_can_wechat_login:', data.is_can_wechat_login);
        if (this.userState.isNeedWeChatLogin == 1 && data.is_can_wechat_login) {
          this.hideWechatLogin = false;
          this.handleWechatLoginVisibility('_bridgeInit');
        } else {
          this.hideWechatLogin = true;
          this.$store.commit('user/CHANGE_STATE', {
            hideWechatLogin: true,
            wechatLoginVisible: false
          });
          this.silentLogin();
        }
        // console.log('H5桥接初始化完成', this.hideWechatLogin);
      });

      thirdPartyLogins((e, cb) => {
        let data = JSON.parse(e);
        // console.log('收到第三方登录请求', data);
        if (data.isHuaWei) {
          this.$store.dispatch('user/huaweiThirdLogin');
        } else {
          this.$store.commit('user/CHANGE_STATE', { username: data.user_name, password: data.origncv });
          this.userState.loginStatus != 2 && this.$store.dispatch('user/login', true);
        }
      });

      innerPurchaseFunctionSuc(async (e, cb) => {
        this.$store.commit('pay/CHANGE_STATE', { yyb_info: JSON.parse(e) });
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      });

      closeOrderFrame((e, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderIframeLink: '',
          orderShow: false,
          chargeOrNot: false
        });
        this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
      });

      checkOrderState((e, cb) => {
        this.$store.dispatch('pay/queryOrderResult');
      });

      deviceFlip2H5((e, cb) => {
        const hidefloat = this.$getStorage('hidefloat');
        if (hidefloat) return;
        this.$store.commit('user/CHANGE_STATE', { suspendVisible: !this.$store.state.user.suspendVisible });
      });

      onBackPressed2H5((e, cb) => {
        if (this.userState.game_url) {
          this.$store.commit('user/CHANGE_STATE', {
            cellLoginVisible: false,
            quickRegisterVisible: false,
            loginVisible: false,
            resetVisible: false
          });
        }
        cb('onBackPressed2H5 success')
      });

      wechatEntryCode(async (e, cb) => {
        let r = null;
        try {
          r = await this.$store.dispatch('user/getWechatCredential', e);
          this.$store.commit('global/showLoading');
          const { user_name, login_credential } = r.content;
          this.credentialLogin({ login_type: 'wechat', last_user_name: user_name, login_credential: login_credential });
        } catch (error) {
          return;
        }
      });
    },

    _clientInit() {
      const { registJSInitial, wechatEntryCode } = require('@/bridge/AppJsBridge');
      
      this.$store.commit('global/showLoading');
      registJSInitial(async (e, cb) => {
        const _data = JSON.parse(e);
        // console.log('Client桥接初始化数据接收完成', _data);
        let hideRegister = false;

        if(CLIENT_LOGIN_WHITE_LIST.has(_data.jh_app_id)){
          this.hideRegister = true;
          if(this.$store.state.user.loginVisible === false){
            this.$store.commit('user/CHANGE_STATE', {
              loginVisible: true,
              cellLoginVisible: false,
              quickRegisterVisible: false,
              argumentVisible: false,
            });
          }
       }

       if(CLIENT_LOGIN_WHITE_ONLY_REG_LIST.has(_data.jh_app_id)){
          // this.hideRegister = false;
          this.hideCellLogin = true;
          this.$store.commit('user/CHANGE_STATE', { loginVisible: true, wechatLoginVisible: false, cellLoginVisible: false });
          // this.hideWechatLogin = false;
        }
      //  console.log('==========', localStorage.getItem('v2LoginType'));
       this._setUserFromClient(_data.user_list);
        this.$store.commit('user/CHANGE_STATE', {
          device_info: _data.attributeReportParams,
          appkey: _data.jh_app_id,
          channel: _data.jh_channel,
          extra_data: JSON.stringify(_data.extra_data),
          game_version: _data.game_version,
          sdk_version: _data.sdk_version,
          third_sdk_status: _data.third_sdk_status || '',
          isEmulator: _data.isEmulator,
          isInstallWeChat: _data.isInstallWeChat,
          isInstallAlipay: _data.isInstallAlipay,
          hideRegister:hideRegister,
        });
        await this.$store.dispatch('user/isNeedWeChatLogin');

        this.$store.commit('global/clearLoading');

        if (_data.is_can_wechat_login) {
          setStorage('is_can_wechat_login', true);
        }

        if (_data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }

        if (_data.is_box_game) {
          this.$setStorage('game_type', 'boxGame');
        }
        if (_data.is_wx_box_game) {
          this.$setStorage('game_type', 'wxBoxGame');
        }
        setStorage('is_use_ks_sdk', _data.is_use_ks_sdk);
        this.isUseKsSdk = _data.is_use_ks_sdk;

        const cacheList = [
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay',
        ];
        await this.$store.dispatch('user/cacheState', cacheList);
        
        this.$store.dispatch('user/getYsdkStatus');
        this.$store.dispatch('pay/judgePayType');
        this.$store.dispatch('user/affiche');
        
        if (this.userState.isNeedWeChatLogin == 1 && _data.is_can_wechat_login) {
          this.hideWechatLogin = false;
          if(localStorage.getItem('v2LoginType') == 'wechat' || !localStorage.getItem('v2LoginType')){
            // console.log('需要微信登录，显示微信登录按钮');
            this.handleWechatLoginVisibility('_clientInit');
          }
        } else {
          this.hideWechatLogin = true;
          this.$store.commit('user/CHANGE_STATE', {
            hideWechatLogin: true,
            wechatLoginVisible: false
          });
          this.silentLogin();
        }
      });

      wechatEntryCode(async (e, cb) => {
        let r = null;
        // console.log('收到微信登录回调，准备获取凭证并登录', e);
        try {
          r = await this.$store.dispatch('user/getWechatCredential', e);
          this.$store.commit('global/showLoading');
          const { user_name, login_credential } = r.content;
          this.credentialLogin({ login_type: 'wechat', last_user_name: user_name, login_credential: login_credential });
        } catch (error) {
          return;
        }
      });
    },

    _setUserFromClient(userList) {
  const localList = getAccount();
  const currentWechatAccount = this.userState.wechatAccount;
  
  // 只有当传入有效用户列表且本地没有数据时才保存
  if (userList && userList.length && (!localList || !localList.length)) {
    const list = userList
      .filter(item => {
        // 关键修复：排除当前正在使用的微信账号
        return item.user_name !== currentWechatAccount;
      })
      .map(item => ({
        username: item.user_name,
        password: item.password,
      }));
    
    if (list.length > 0) {
      saveAccountList(list);
    }
  }
  
  // 统一刷新用户列表
  setTimeout(() => {
    this.$refs.loginRef?.getUserList();
  }, 500);
},

    closeVipCustomer() {
      if (this.isClient) {
        const { registReturnGameFunction } = require('@/bridge/AppJsBridge');
        registReturnGameFunction(null);
      } else {
        this.$store.commit('user/CHANGE_STATE', { vipVisible: false });
      }
    },

    openUrl(url) {
      if (this.isClient) {
        const { gameOpenDownloads } = require('@/bridge/AppJsBridge');
        gameOpenDownloads({
          gameUrl: url
        });
      }
    },

    captchaInit() {
      CaptchaInit(
        "captcha",
        (data) => {
          this.$store.commit("user/CHANGE_STATE", { captchaVisible: false });
          CaptchaReset();
          this.registerCallback && this[this.registerCallback](data);
        },
        (err) => {
          CaptchaReset();
          console.log(err);
        }
      );
    },

    _handleType() {
      const v2LoginType = localStorage.getItem('v2LoginType');
      const normalUserList = getAccount() || [];
      const cellUserList = getCellAccount() || [];
      
      if ((!v2LoginType && !cellUserList.length && normalUserList.length) || v2LoginType == 'normal') {
        if(CLIENT_AUTOLOGIN_WHITE_LIST.has(String(getStorage('appkey'))) && getStorage('isAutoLoginChecked')){
          this.$nextTick(() => {
            this.toLogin();
          });
        }else{
          this.redirectAccountLogin();
        }

      } else if (v2LoginType == 'wechat') {
        // console.log('_handleType: 需要微信登录，检查凭证缓存', getStorage('isNeedWeChatLogin'),getStorage('is_can_wechat_login'));
        if(getStorage('isNeedWeChatLogin') == 1 && getStorage('is_can_wechat_login')){
          const { hasCredential, wechat_login_credential, wechatAccount } = this.checkWechatCredentialCache();
          // console.log('_handleType: client=', this.isClient, 'hasCredential=', hasCredential);
          // console.log('_handleType: !this.isClient=', !this.isClient, 'condition=', (hasCredential && !this.isClient));
          this.handleWechatLoginVisibility('_handleType');
          if (hasCredential) {
            // 有凭证且不是客户端：关闭所有页面，直接登录
            // console.log('_handleType: 检测到微信登录凭证，直接登录');
            this.$nextTick(() => {
              this.credentialLogin({ 
                login_type: 'wechat', 
                last_user_name: wechatAccount, 
                login_credential: wechat_login_credential 
              });
            });
          }
          //  else {
          //   // 无凭证或是客户端：显示微信登录页面
          //   console.log('_handleType: 显示微信登录页面');
          //   this.showWechatSelectOther = true;
          // }
        }else{
          this.redirectAccountLogin();
        }
      }
    },

    agreeArgument() {
      const { method, params } = this.argumentHandle;
      this.argumentTipVisible = false;
      this[method]({
        ...params,
        agreementState: true
      });
    },

    setRegisterCallback(cb, form) {
      this.registerCallback = cb;
      if (form) this.cellForm = form;
    },

    async toLogin() {
      const r = await this.$store.dispatch('user/login');
      this.setLastLoginType('normal');
      // console.log('普通登录结果');
      localStorage.setItem('agreement_flag', 1);
      
      if (r.content.login_status) {
        this.$store.commit('global/clearLoading');
        return;
      }

      // 关键修复：只有普通登录且不是微信账号时才保存
      const isWechatAccount = this.userState.username === this.userState.wechatAccount;
      if (!isWechatAccount) {
        // 这是真正的普通账号登录，可以保存
        saveAccount(this.userState.username, this.userState.password);
      }

      const { force_bind_tel, show_tel_bind } = r.content;
      if ([1, 2, 3].includes(force_bind_tel) || show_tel_bind) {
        if (show_tel_bind && ![1, 2, 3].includes(force_bind_tel)) this.normalTelBind = true;
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: true });
        this.$store.commit('global/clearLoading');
        return;
      }
      
      this.handleLoginInfo();
    },

    async cellLogin(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'cellLogin',
          params: form
        };
        this.argumentTipVisible = true;
        return;
      }
      try {
        const r = await this.$store.dispatch('user/cellLogin', form);
        this.setLastLoginType('cell');
        // console.log('222手机登录结果');
        localStorage.setItem('agreement_flag', 1);
        
        if (r.content.login_credential && !form.credential) {
          saveCellAccount(form.tel_num, r.content.login_credential);
        }

        if (r.content.login_status) {
          this.$store.commit('global/clearLoading');
          return;
        }
        
        const { force_bind_tel } = r.content;
        if ([1, 2, 3].includes(force_bind_tel)) {
          this.$store.commit('user/CHANGE_STATE', { forceBindVisible: true });
          this.$store.commit('global/clearLoading');
          return;
        }
        this.handleLoginInfo();
      } catch (error) {
        if (error.ret && error.ret === 194) {
          delCellAccount(form.tel_num);
          setTimeout(() => {
            this.$refs.cellLogin.getCellList(1);
          });
        }
      }
    },

    handleLoginInfo() {
      this.$store.dispatch('user/checkVip');

      if (this.isClient) {
        this.handleClientLoginInfo();
      } else {
        this.$store.dispatch('user/checkAntiIndulged').then(() => {
          this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: true });
          this.$store.commit('global/clearLoading');
        }).catch(() => this.enterGame());
      }
    },

    async handleClientLoginInfo() {
      await this.$store.dispatch('user/checkVip');
      await this.handleNotifyInfo();

      setStorage('isAutoLoginChecked', true);
      
      this.$store.dispatch('user/checkAntiIndulged')
        .then(() => {
          this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: true });
          this.$store.commit('global/clearLoading');
        })
        .catch(() => this.notifyLoginSuccess());
    },

    async handleNotifyInfo() {
      const { is_vip, vip_type } = this.userState;
      const { FLOAT_URL, vipPushLink, activityLink } = require('@/config');
      
      this.notifyInfo = {
        session_id: this.userState.session_id,
        user_id: this.userState.user_id,
        user_name: this.userState.username,
        password: this.userState.password,
        ios_password: this.userState.password,
        login_flag: 1,
        bind_flag: 0,
        bind_status: this.userState.tel_status == 0 ? 1 : 0,
        access_token: this.userState.access_token,
        id_card_status: this.userState.id_card_status,
        force_bind_tel: this.userState.force_bind_tel,
        register_time: this.userState.register_time,
        is_open_activity_url: false,
        activity_url: '',
        is_vip: this.userState.is_vip,
        vip_push: vip_type == 2 && is_vip ? vipPushLink : '',
        float_url: FLOAT_URL,
        activityLink,
        menu_list: [],
        update_gift_url: this.userState.update_gift_status === 1 ? `${window.location.origin}/h5sdk/update-gift` : '',
        is_silent_login: this.$getStorage('isSilentLogin') || false,
      };
    },

    async notifyLoginSuccess() {
      const { registLoginVerifySuccessFunction } = require('@/bridge/AppJsBridge');
      registLoginVerifySuccessFunction({
        ...this.notifyInfo
      });
    },

    antiIndulgedLogin(anti_indulged_info) {
      this.notifyInfo = {
        ...this.notifyInfo,
        anti_indulged_info,
        anti_indulged_url: `${window.location.origin}/h5sdk/client/antiIndulged`,
      };
      const { registLoginVerifySuccessFunction } = require('@/bridge/AppJsBridge');
      registLoginVerifySuccessFunction(this.notifyInfo);
    },

    closeForceBind(type) {
      const { force_bind_tel } = this.userState;
      if (!type && force_bind_tel == 1) {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
      } else {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
        this.$store.commit('global/showLoading');
        this.handleLoginInfo();
      }
    },

    enterGame() {
      if (this.userState.antiIndulgedVisible) {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: false });
        this.$store.commit('global/showLoading');
      }
      if (this.userState.h5Preload) {
        this.$store.dispatch('message/notifyLogin');
      } else {
        this.$store.dispatch('message/monitorInit');
        this.$store.commit('user/CHANGE_STATE', { gameVisible: true });
      }
    },

    handleLogin(form) {
      if (form && !form.agreementState) {
        this.argumentHandle = {
          method: 'handleLogin',
          params: form
        };
        this.argumentTipVisible = true;
        return;
      }
      this.$store.commit('user/CHANGE_STATE', form);
      this.toLogin();
    },

    redirectRegist() {
      this.$store.dispatch('user/refreshOaid');
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
        loginVisible: false,
        quickRegisterVisible: true,
        cellLoginVisible: false,
      });
    },

    async redirectWechatLogin() {
      this.$store.dispatch('user/refreshOaid');
      this.$store.commit('global/showLoading', '正在跳转微信登录...');
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
        loginVisible: false,
        quickRegisterVisible: false,
        cellLoginVisible: false,
      });
      await this.$store.dispatch('user/weChatLogin', this.$route.query);
    },

    redirectCellLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: false,
        cellLoginVisible: true,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },

    redirectAccountLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: true,
        cellLoginVisible: false,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },

    argumentReturn() {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
      });
    },

    redirectForget() {
      this.$store.commit('user/CHANGE_STATE', {
        loginVisible: false,
        resetVisible: true
      });
    },

    redirectLogin() {
      this.$store.commit('user/CHANGE_STATE', {
        cellLoginVisible: false,
        quickRegisterVisible: false,
        resetVisible: false,
        loginVisible: true
      });
    },

    async handleQuickRegister(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'handleQuickRegister',
          params: {}
        };
        this.argumentTipVisible = true;
        return;
      }
      if (this.captchaStatus == '1') {
        this.$store.commit('user/CHANGE_STATE', { captchaVisible: true });
        this.setRegisterCallback('captchaQuickRegister');
        return;
      }
      await this.$store.dispatch('user/quickRegister');
      this.toLogin();
    },

    closeAffiche() {
      this.$store.commit('user/CHANGE_STATE', { afficheShow: false });
      if (this.isClient) {
        const { affiche_info } = this.userState;
        if (affiche_info && affiche_info.login_state == 0) {
          this.$store.commit('global/showLoading');
          this.handleLoginInfo();
        }
      }
    },

    closeChargeWindow() {
      this.$store.commit('user/CHANGE_STATE', { chargeVisible: false });
      if (this.isCx) {
        const params = {
          code: 2,
          msg: '取消支付',
        };
        window.frames['gameFrame'] && window.frames['gameFrame'].postMessage({ action: 'getOrderStateCallback', params }, '*');
      }
    },

    closeUpdateGift() {
      this.$store.commit('user/CHANGE_STATE', { updateGiftVisible: false });
    },

    closeGuideRemind() {
      this.$store.commit('pay/CHANGE_STATE', { guideRemindVisible: false });
    },

    redirectArgument(type) {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: true,
        argumentType: type
      });
    },

    hideGuideBrowser() {
      this.$store.commit('pay/CHANGE_STATE', {
        guideBrowserVisible: false
      });
    },

    async handleWchatLoginSubmit() {
      this.$store.commit('global/showLoading');
      const { wechatAccount, wechat_login_credential } = this.userState;
      if (!wechatAccount || !wechat_login_credential) {
        this.$store.commit('global/clearLoading');
        this.redirectWechatLogin();
      } else {
        this.credentialLogin({ login_type: 'wechat', last_user_name: wechatAccount, login_credential: wechat_login_credential });
      }
    },

    wechatLoginRedirectOther() {
      if (this.isCx){
        this.$store.commit('user/CHANGE_STATE', {
          wechatLoginVisible: false,
          wechatBindPhoneVisible: false,
          cellLoginVisible: false,
          loginVisible: true,
        });
      }else{
        this.$store.commit('user/CHANGE_STATE', {
          wechatLoginVisible: false,
          wechatBindPhoneVisible: false,
          loginVisible: false,
          cellLoginVisible: true,
        });
      }
    },

    otherLoginRedirectWechat() {
      this.$store.commit('user/CHANGE_STATE', {
        wechatLoginVisible: true,
        wechatBindPhoneVisible: false,
        cellLoginVisible: false,
        wechatAccount: this.userState.wechatAccount,
        wechat_login_credential: this.userState.wechat_login_credential,
      });
    },

    async credentialLogin({ login_type, last_user_name, login_credential }) {
      let r = null;
      try {
        r = await this.$store.dispatch('user/credentialLogin', {
          last_user_name,
          login_credential,
          isH5: !this.isClient,
        });
        
        if(r.ret == 1){
          this.$store.commit('user/CHANGE_STATE', {
            wechat_login_credential: r.content.login_credential,
            wechatAccount: r.content.user_name
          });
          
          // 关键修复：凭证登录成功后，确保不将微信账号保存到普通账号列表
          const normalUserList = getAccount() || [];
          const isWechatAccountInNormalList = normalUserList.some(item => 
            item.username === r.content.user_name
          );
          
          if (isWechatAccountInNormalList) {
            // 如果微信账号被错误地保存在普通账号列表中，移除它
            const filteredList = normalUserList.filter(item => 
              item.username !== r.content.user_name
            );
            saveAccountList(filteredList);
            // console.log('凭证登录：已从普通账号列表中移除微信账号:', r.content.user_name);
          }
        } else {
          this.$store.commit('global/clearLoading');
          this.redirectWechatLogin();
          return;
        }
      } catch (error) {
        this.$store.commit('user/CHANGE_STATE', {
          wechat_login_credential: '',
          wechatAccount: ''
        });
        this.redirectWechatLogin();
        return;
      }
      
      this.setLastLoginType(login_type);
      // console.log(`${login_type}凭证登录结果`);
      
      if (login_type == 'wechat') {
        this.handleWechatLoginBindPhone(r.content.tel_status);
      }
    },

    async handleWechatLoginBindPhone(tel_status) {
      if (tel_status == 0) {
        const { user_id, appkey } = this.userState;
        const telConfig = await telBindShow({ user_id, appkey });
        const default_bind_cache = this.$getStorage('default_bind_cache') || '';
        
        if ((telConfig.content.default_bind_status == 1 && !default_bind_cache) || telConfig.content.tel_bind_show == 1) {
          this.$setStorage('default_bind_cache', 1);
          this.$store.commit('global/clearLoading');
          this.$store.commit('user/CHANGE_STATE', {
            wechatBindPhoneVisible: true,
            wechatLoginVisible: false,
          });
          this.config_bind_force = telConfig.content.config_bind_force;
        } else {
          this.$store.commit('user/CHANGE_STATE', {
            wechatBindPhoneVisible: false,
            wechatLoginVisible: false,
          });
          this.handleLoginInfo();
        }
      } else {
        this.handleLoginInfo();
      }
    },

    setLastLoginType(type) {
      // console.log('设置最后登录类型为:', type);
      localStorage.setItem('v2LoginType', type);
    },

    async captchaQuickRegister(validData) {
      await this.$store.dispatch('user/quickRegister', validData);
      await this.toLogin();
    },

    async silentLogin() {
      if (!this.$getStorage('isSilentLogin')) return;
      await this.$store.dispatch('user/silentLogin');
      const { affiche_info } = this.userState;
      if (affiche_info && affiche_info.login_state == 0) {
        return;
      }
      this.handleLoginInfo();
    }
  }
};
</script>

<style lang="scss" module>
.container {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;

  &.h5Container {
    /* H5 特定样式 */
  }

  &.clientContainer {
    width: 100%;
    height: 100%;
  }

  .gameFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  .mask {
    background: rgba(255, 59, 54, 1);
  }

  .outer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // 防止内部元素引起外部布局变化
    contain: layout style paint;
  }

  .argumentTip {
    z-index: 99;
  }

  .argument {
    z-index: 100;
  }

  .wechatLogin {
    z-index: 98;
  }

  .wechatBindPhone {
    z-index: 98;
  }

  .captcha {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 350px;
    height: 270px;
  }

  .hint {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    padding: 5px 15px;
    font-size: 14px;
    background-color: #ededf9;
    
    > span {
      color: #FF3B36;
    }
  }

  .guideBrowser {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }

  .vipCustomer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.6);
    
    .window {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 370px;
      height: 260px;
    }
  }
}
</style>
